/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import {
  Button, NumberInput,
  PasswordInput,
  TextInput
} from "@mantine/core";
import { useForm } from "@mantine/form";
import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Halment from "../../faetures/Halment";
import logo from "../../images/logo1.png";
import { userRegister } from "../../redux/actions/frontendActions/authenticationAction";
function Register({history}) {
const dispatch = useDispatch();
  const [loadImage, setLoadImage] = useState("");
  const [img, setImg] = useState("");

  const {successMessage,error,authenticate ,loading} = useSelector(state=>state.Auth);

  


  const form = useForm({
    initialValues: {
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      password: "",
  
    },

  

    validate: {
      firstName: (value) =>
        value.length < 2 ? "First Name rquired  with 2 caracter " : null,
      lastName: (value) =>
        value.length < 2 ? "Last Name required with 2 caracter" : null,
      phone: (value) =>
        value.length < 11 ? "Phone number would be 11 digits" : null,

      email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
      password: (value) =>
        value.length < 6 ? "Password Must be 6 caracter" : null,
    },
  });

  // handle image

  const fileHendle = (e) => {
    if (e.target.files.length !== 0) {
      setImg({
        ...img,
        [e.target.name]: e.target.files[0],
      });
    }

    const reader = new FileReader();

    reader.onload = () => {
      setLoadImage(reader.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  // handle form 

  const handleFormSubmit =(e) => {
   const {firstName ,lastName , email , phone , password} =form.values;
   const {image} =img;
  const formData =  new FormData();
  formData.append("firstName" , firstName)
  formData.append("lastName" , lastName)
  formData.append("email" , email)
  formData.append("phone" , phone)
  formData.append("password" , password)
  formData.append("image" , image)
  dispatch(userRegister(formData))


  }
  
  useEffect(()=>{
    if(authenticate){
        history.push('/')
    }
    if(successMessage){
        toast.success(successMessage);
        dispatch({type :"SUCCESS_MESSAGE_CLEAR"})
    }
    if(error){
        toast.error(error);
        dispatch({type :"ERROR_CLEAR"})
    }
},[successMessage,error])

  return (
    <div className="authentication_wrapper">
       <Halment title="Register Account" />
          <Toaster
          position="bottom-right"
          reverseOrder={false}
          toastOptions={{
            style: {
              fontSize: "14px",
            },
          }}
        />
      <div className="logo_area">
        <Link to="/">
          <img src={logo} alt="" />
        </Link>
      </div>

      <div className="authentication-area">
        <div className="authentication_form_area">
          <div className="form_top">
            <div className="text">Sign up</div>
            <div className="render">
              <Link to="/login">Already have an account?</Link>
            </div>
          </div>
          <form onSubmit={form.onSubmit(handleFormSubmit)}>
            <div className="form_item form_flex">
              <div className="form_flex_item">
                <TextInput
                  withAsterisk
                  label="First Name"
                  placeholder="Jhon"
                  {...form.getInputProps("firstName")}
                />
              </div>
              <div className="form_flex_item">
                <TextInput
                  withAsterisk
                  label="Last Name"
                  placeholder="Doe"
                  {...form.getInputProps("lastName")}
                />
              </div>
            </div>
            <div className="form_item">
              <NumberInput
                withAsterisk
                label="Phone"
                placeholder="Phone"
                {...form.getInputProps("phone")}
              />
            </div>
            <div className="form_item">
              <TextInput
                withAsterisk
                label="Email Address"
                placeholder="your@email.com"
                {...form.getInputProps("email")}
              />
            </div>
            <div className="form_item">
              <PasswordInput
                placeholder="Password"
                label="Password"
                // description="Password must include at least one letter, number and special character"
                withAsterisk
                {...form.getInputProps("password")}
              />
            </div>

            <div className="form_item">

              <input type="file" name="image" id=""    onChange={fileHendle} />
              {/* <FileInput
                label="Upload files"
                name="image"
                onChange={fileHendle}
                placeholder="Upload files"
              
              /> */}
            </div>

            <div className="form_item">
              <div className="term">
                <p>
                  By Signing up, you agree to our{" "}
                  <Link to="/"> Terms of Service</Link> and{" "}
                  <Link to="/"> Privacy Policy</Link>{" "}
                </p>
              </div>
            </div>
            <div className="form_item">
              <div className="submit_button">
                <Button type="submit" variant="filled">
                  {
                    loading ? "Creating Account....": "Create Account"
                  }
                 
                </Button>
              </div>
            </div>
            <div className="account_image">
                    {loadImage ? <img src={loadImage} /> : ""}
                  </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Register;
